import React from 'react';
import { Link } from 'react-router-dom';
import Env from '../model/Env'

const TopToolbar = (props) => {
	return (
		<div className="top-toolbar container-fluid d-xs-none">
			<div className="row py-2">
				<div className="col-6 align-middle">
					<i className="fa fa-map-marker fa-2x" aria-hidden="true"></i>
					<span className="ml-2">Unit 306 Prestige Tower, F. Ortigas Jr. Road, Ortigas Center, Pasig City</span>
				</div>
				<div className="col-6 text-right">
					<i className="fa fa-envelope fa-2x" aria-hidden="true"></i>
					<span className="ml-2"><a href={"mailto:"+Env.SUPPORT_EMAIL}>{Env.SUPPORT_EMAIL}</a></span>
					<Link to="/help" className="btn btn-default btn-sm px-3 ml-3">Help</Link>
				</div>
			</div>
		</div>
	);
}

export default TopToolbar;


// WEBPACK FOOTER //
// ./src/view/TopToolbar.js